import { Controller } from "@hotwired/stimulus"

console.log("qr_scanner_controller.js file loaded");

export default class extends Controller {
  static targets = ["reader", "status"]

  connect() {
    this.scanner = null;
    console.log("QR Scanner Controller connected to:", this.readerTarget.id);
  }

  async startScanner(event) {
    if (event) event.preventDefault();
    
    const statusEl = this.statusTarget;
    const readerId = this.readerTarget.id;
    
    console.log("Attempting to start scanner for ID:", readerId);
    statusEl.textContent = "Checking camera availability...";

    if (typeof Html5Qrcode === "undefined") {
      statusEl.textContent = "Error: QR Library not loaded.";
      return;
    }

    try {
      // 1. Force permission check via browser API
      statusEl.textContent = "Requesting camera permission...";
      const stream = await navigator.mediaDevices.getUserMedia({ video: { facingMode: "environment" } });
      
      // Stop the test stream
      stream.getTracks().forEach(track => track.stop());
      console.log("Camera permission granted.");

      // 2. Initialize scanner
      if (this.scanner) {
        await this.scanner.stop().catch(() => {});
      }
      
      this.scanner = new Html5Qrcode(readerId);
      
      const config = { 
        fps: 10, 
        qrbox: { width: 250, height: 250 },
        aspectRatio: 1.0
      };

      // Hide start button
      if (event && event.currentTarget) {
        event.currentTarget.classList.add('hidden');
      }

      await this.scanner.start(
        { facingMode: "environment" },
        config,
        (decodedText) => this.handleScan(decodedText)
      );

      statusEl.textContent = "Scanning... Point at client QR code.";
      console.log("Scanner started successfully.");

    } catch (err) {
      console.error("Scanner Error:", err);
      statusEl.textContent = `Camera Error: ${err.message || err}`;
      if (event && event.currentTarget) {
        event.currentTarget.classList.remove('hidden');
      }
    }
  }

  handleScan(url) {
    console.log("QR Code detected:", url);
    this.statusTarget.textContent = "Verifying...";
    this.stopScanner();

    fetch(url, {
      method: "POST",
      headers: {
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
        "Accept": "application/json"
      }
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        this.statusTarget.innerHTML = `<span class="text-green-600 font-black">${data.message}</span>`;
        setTimeout(() => window.location.reload(), 1000);
      } else {
        this.statusTarget.innerHTML = `<span class="text-red-600 font-black">${data.message}</span>`;
      }
    })
    .catch(err => {
      console.error("Check-in error:", err);
      this.statusTarget.textContent = "Network error. Try manual check-in.";
    });
  }

  stopScanner() {
    if (this.scanner) {
      this.scanner.stop().then(() => {
        this.scanner = null;
        this.statusTarget.textContent = "Scanner stopped.";
      }).catch(err => console.warn("Stop error:", err));
    }
  }

  disconnect() {
    this.stopScanner();
  }
}
